
export default function useRecentStays() {
  const isLoading = false;
  const stays = []; 
const confirmedStays = []; 
const numDays = 0; 

  return { stays, isLoading, confirmedStays, numDays };
}
